import { SEO_TITLE_PASSWORD_RESET } from 'mk/autogenerated/translations/PasswordResetChoosePage.91500f0b15699cdbee12a1b2703e5530'
import { PasswordResetChoose } from 'mk2/apps/users/containers/PasswordResetChoose/PasswordResetChoose';
import { loginUrl } from 'mk2/apps/users/urls';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState } from 'mk2/reducers';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps {}

interface DispatchProps {}

export type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class PasswordResetChoosePage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {};
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {};
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_PASSWORD_RESET;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <PasswordResetChoose {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return loginUrl;
    }

    public registerInStore(store: Store<AppState>) {
        // nothing to do
    }
}
